const BG_TEXT_CLASSES = [
  { bg: "bg-emerald-500/20", text: "text-emerald-300" },
  { bg: "bg-blue-500/20", text: "text-blue-300" },
  { bg: "bg-cyan-500/20", text: "text-cyan-300" },
  { bg: "bg-indigo-500/20", text: "text-indigo-300" },
  { bg: "bg-violet-500/20", text: "text-violet-300" },
  { bg: "bg-amber-500/20", text: "text-amber-300" },
]

export function getAvatarInitialColor(seed) {
  const s = (seed ?? "").toString().trim()
  const ch = s.length ? s[0].toUpperCase() : "?"
  const codeSum = Array.from(ch).reduce((acc, c) => acc + c.charCodeAt(0), 0)
  const idx = codeSum % BG_TEXT_CLASSES.length
  return `${BG_TEXT_CLASSES[idx].bg} ${BG_TEXT_CLASSES[idx].text}`
}

export function formatTimeAgo(createdAtMs) {
  if (!createdAtMs) return "Just now"
  const ms = Date.now() - createdAtMs
  if (ms < 0) return "Just now"

  const seconds = Math.floor(ms / 1000)
  if (seconds < 60) return `${seconds}s ago`

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`

  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

